import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Please note that the `}<a parentName="p" {...{
          "href": "/api/../api/projects/order-edits"
        }}>{`Order Edit`}</a>{` API does not support tracking or reserving of inventory. An OrderEdit can be created only if the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#inventorymode"
        }}>{`InventoryMode`}</a>{` of the Order and its `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItems`}</a>{` is `}<inlineCode parentName="p">{`"None"`}</inlineCode>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      